<template>
    <button
        class="group themeButton relative flex gap-2 items-center group px-3 py-1 text-xs themeColor rounded-lg"
        :style="{ height: buttonSize, width: buttonSize, padding: buttonPadding, justifyContent: buttonAlign, alignItems: buttonAlign }"
        :class="buttonClass">
        <label v-if="icon" :for="forName" class="cursor-pointer">
            <Icon v-if="icon" :icon="icon" :width="iconSize" :height="iconSize" />
        </label>
        <span v-if="loading" class="animate-spin mr-2 flex items-center">
            <loading-icon />
        </span>
        <span v-if="title">{{ title }}</span>
        <Transition>
            <span
                class="hidden transition-all group-hover:flex justify-center themeButtonTooltip text-gray-700 dark:text-gray-400"
                v-if="tooltip">{{ tooltip }}</span>
        </Transition>
    </button>
</template>
<script>
import { Icon } from '@iconify/vue';
import LoadingIcon from "@/Common/LoadingIcon.vue";
export default {
    name: "ButtonCard",
    components: {
        Icon, LoadingIcon
    },
    props: {
        title: {
            type: String,
            default: "",
        },
        icon: {
            type: String,
            default: ""
        },
        forName: {
            type: String,
            default: ""
        },
        buttonClass: {
            type: String,
            default: ""
        },
        loading: {
            type: String,
            default: ""
        },
        tooltip: {
            type: String,
            default: ""
        },
        iconSize: {
            type: String,
            default: ""
        },
        buttonSize: {
            type: String,
            default: ""
        },
        buttonPadding: {
            type: String,
            default: ""
        },
        buttonAlign: {
            type: String,
            default: ""
        }
    },
    methods: {

    },
}
</script>